import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const FixedExecutionEnvironmentDescription = () =>
  <Paragraph>
    <strong>
      <Color variant='theme-description-text'>
        Link this SUT to a specific execution environment. Use for setups like single-system, iOS, or hardware-connected environments that require a fixed test machine.
      </Color>
    </strong>
  </Paragraph>

export default FixedExecutionEnvironmentDescription
